/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import classNames from 'classnames';
import { Row, Col, Form, Card, Image } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import i18n from 'i18next';
import { loadCaptchaEnginge, validateCaptcha } from 'react-simple-captcha';
import * as actions from '../../../../../../store/actions/index';
import { toastifyConstant } from '../../../../../../helpers';
import { onPasteHelper } from '../../../../../../helpers/onPasteHelper';

import logo from '../../../../assets/images/small-logo.png';
import './Newsletter.scss';

const Newsletter = () => {
  const dispatch = useDispatch();
  const { newsletterSubscribe } = useSelector(
    (state) => state.userRegistration
  );
  const { newsletterStatus } = useSelector((state) => state.recaptcha);

  useEffect(() => {
    dispatch(actions.getRecaptcha());
  }, [dispatch]);

  useEffect(() => {
    if (newsletterSubscribe?.successData) {
      if (newsletterSubscribe?.successData?.status === 'success') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        toast.success(newsletterSubscribe?.successData?.data?.data, {
          toastifyConstant,
          toastId: 'success',
        });
        dispatch(actions.clearSubscribeNewsletterMessage());
        reset();
      } else if (newsletterSubscribe?.successData?.status === 'fail') {
        toast.error(newsletterSubscribe?.successData?.data?.data, {
          toastifyConstant,
          toastId: 'error',
        });
        dispatch(actions.clearSubscribeNewsletterMessage());
      }
    }
  }, [dispatch, newsletterSubscribe]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
    trigger,
  } = useForm({
    mode: 'onTouched',
  });

  useEffect(() => {
    onPasteHelper(setValue, trigger);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = (data) => {
    if (newsletterStatus) {
      let user_captcha_value =
        document.getElementById('user_captcha_input').value;
      if (validateCaptcha(user_captcha_value) === true) {
        dispatch(actions.subscribeNewsletter(data));
        loadCaptchaEnginge(6);
        document.getElementById('user_captcha_input').value = '';
        document.getElementById('email').value = '';
      } else {
        toast.error(i18n.t('captcha.fail'), {
          toastifyConstant,
          toastId: 'error',
        });
      }
    } else {
      dispatch(actions.subscribeNewsletter(data));
    }
  };

  useEffect(() => {
    if (newsletterStatus) {
      loadCaptchaEnginge(6);
    }
  }, [newsletterStatus]);

  return (
    <Card.Body className="px-0">
      {/* <Container>
        <Row className="justify-content-between align-items-center">
          <Col md={6}>
            <Heading
              alignCenter={false}
              title={`${i18n.t("home.newsletter.title")} ${meta?.siteName}`}
              brif={i18n.t("home.newsletter.brif")}
            />
            <Card.Body className="newsletter-form-wrapper">
              <Form name="form" onSubmit={handleSubmit(onSubmit)}>
                <Form.Group as={Col} className="mb-0 newsletter-form-input">
                  <Form.Control
                    type="text"
                    placeholder={i18n.t("home.newsletter.email")}
                    name="email"
                    autoComplete="off"
                    id="newsletterEmail"
                    className={classNames({
                      "is-invalid": errors?.email,
                    })}
                    {...register("email", {
                      required: i18n.t("common.required"),
                      pattern: {
                        value:
                          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        message: i18n.t("yup.validEmailAddress"),
                      },
                    })}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="email"
                    render={({ message }) => (
                      <span
                        className="invalid-feedback d-block"
                        id="newsletterEmailErr">
                        {message}
                      </span>
                    )}
                  />
                  <FontAwesomeIcon
                    icon={["far", "envelope"]}
                    className="newsletter-form-icon"
                  />
                </Form.Group>

                {newsletterStatus ? (
                  <Row className="captch-form-row">
                    <Card.Body className="captcha-form-main-wrap">
                      <Card.Body className="captcha-code-wrap">
                        <LoadCanvasTemplateNoReload />
                      </Card.Body>
                      <Form.Control
                        type="text"
                        placeholder={i18n.t("common.enterCaptcha")}
                        name="user_captcha_input"
                        id="user_captcha_input"
                        autoComplete="off"
                        className={`captcha-form ${classNames({
                          "is-invalid": errors?.user_captcha_input,
                        })}`}
                        {...register("user_captcha_input", {
                          required: i18n.t("errors.required"),
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="user_captcha_input"
                        render={({ message }) => (
                          <span
                            className="invalid-feedback"
                            id="newsletterCaptchaErr">
                            {message}
                          </span>
                        )}
                      />
                    </Card.Body>
                  </Row>
                ) : null}

                <Card.Body className="text-center">
                  <Button
                    id="newsletterSubmit"
                    variant="primary"
                    type="submit"
                    className={`w-100 ${!newsletterStatus ? "mt-5" : ""}`}>
                    {i18n.t("home.newsletter.submitButton")}
                  </Button>
                </Card.Body>
              </Form>
            </Card.Body>
          </Col>
          <Col md={5} className="newsletter-icon">
            <img
              src={
                projectScriptType === 0
                  ? newsletterIcon
                  : realEstateNewsletterIcon
              }
              alt=""
            />
          </Col>
        </Row>
      </Container> */}

      <Row className="mb-4">
        <Col xs="auto">
          <Image
            src={logo}
            alt="Logo"
          />
        </Col>
        <Col>
          <h5 className="newsletter-title mb-2">
            {i18n.t('home.newsletter.title')}
          </h5>
          <p className="newsletter-text">{i18n.t('home.newsletter.brif')}</p>
        </Col>
      </Row>
      <Form
        name="form"
        onSubmit={handleSubmit(onSubmit)}
        className="newsletter-form"
      >
        <Form.Group
          as={Col}
          className="mb-0 newsletter-form-input"
        >
          <Form.Control
            type="text"
            placeholder={i18n.t('home.newsletter.email')}
            name="email"
            autoComplete="off"
            id="newsletterEmail"
            className={classNames('', {
              'is-invalid': errors?.email,
            })}
            {...register('email', {
              required: i18n.t('common.required'),
              pattern: {
                value:
                  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: i18n.t('yup.validEmailAddress'),
              },
            })}
          />
          <ErrorMessage
            errors={errors}
            name="email"
            render={({ message }) => (
              <span
                className="invalid-feedback d-block"
                id="newsletterEmailErr"
              >
                {message}
              </span>
            )}
          />
          <FontAwesomeIcon
            icon={['fas', 'paper-plane']}
            className="newsletter-form-icon"
            onClick={handleSubmit(onSubmit)}
          />
        </Form.Group>
      </Form>
    </Card.Body>
  );
};

export default Newsletter;
